/* eslint-disable no-console */
import { client } from "./supabase";

/**
 * Fuente ÚNICA (10.1) de la resolución "quién era el dueño de un edificio en tal fecha", para los
 * reportes que agrupan comisión por dueño/fondo (CalculadorComisionEdificio, EstadoCuenta). Reemplaza
 * la lectura del valor ACTUAL de `edificios.alianza` (que atribuía mal la historia vieja al dueño de
 * hoy). El historial vive en `edificio_socio_historial` (Fase 1); `edificios.alianza` queda de respaldo.
 */

/**
 * Devuelve el `socio_id` vigente para `edificioId` en `fechaStr` (YYYY-MM-DD), o NULL si ninguna fila
 * del historial cubre esa fecha. NO silencioso (10.177): el NULL lo maneja el caller (loggear el caso
 * en vez de omitirlo mudo), no se traga acá.
 * @param {Map<number, Array<{socio_id:number, fecha_inicio:string, fecha_fin:string|null}>>} historialPorEdificio
 */
export const socioEnFecha = (historialPorEdificio, edificioId, fechaStr) => {
  if (!historialPorEdificio || edificioId == null || !fechaStr) return null;
  const rows = historialPorEdificio.get(Number(edificioId)) || [];
  const f = String(fechaStr).slice(0, 10);
  const hit = rows.find((r) => r.fecha_inicio <= f && (r.fecha_fin == null || f <= r.fecha_fin));
  return hit ? hit.socio_id : null;
};

/**
 * Carga el catálogo de dueños del país (`socios_edificio`) + el historial de dueño por edificio
 * (`edificio_socio_historial`) en un Map keyed por `edificio_id`. Una sola llamada por reporte.
 * @returns {Promise<{socios: Array<{id:number, nombre:string, pais:string}>, historialPorEdificio: Map}>}
 */
export const cargarHistorialSocios = async (pais) => {
  const [sociosRes, histRes] = await Promise.all([
    client.from("socios_edificio").select("id, nombre, pais").eq("pais", pais).order("nombre"),
    client.from("edificio_socio_historial").select("edificio_id, socio_id, fecha_inicio, fecha_fin"),
  ]);
  // No tragar el error a [] en silencio (10.170): dejar traza y degradar a vacío (el reporte sigue,
  // sin agrupación por dueño, en vez de romper).
  if (sociosRes.error) console.error("cargarHistorialSocios/socios", sociosRes.error);
  if (histRes.error) console.error("cargarHistorialSocios/historial", histRes.error);

  const historialPorEdificio = new Map();
  for (const r of histRes.data || []) {
    const k = Number(r.edificio_id);
    if (!historialPorEdificio.has(k)) historialPorEdificio.set(k, []);
    historialPorEdificio.get(k).push({
      socio_id: Number(r.socio_id),
      fecha_inicio: r.fecha_inicio,
      fecha_fin: r.fecha_fin,
    });
  }
  return { socios: sociosRes.data || [], historialPorEdificio };
};
